// 默认 PageContainer 的 一些设置
export const PageContainerSystem = {
  breadcrumbRender: false,
  title: false,
};
